import React from 'react';
import { Route, RouteProps } from 'react-router-dom';

const PublicRoute: React.FunctionComponent<RouteProps> = (props) => <Route {...props} />;

export default PublicRoute;
